import React from 'react';
import styles from './PositionalGrid.module.css';

const PositionalGrid = ({ metrics }) => {
    return (
        <div className={styles['positional-grid']}>
            {metrics.map((metric, index) => (
                <div key={index} className={styles['positional-tile']}>
                    <span className={styles['positional-value']}>{metric.value}</span>
                    <span className={styles['positional-label']}>{metric.label}</span>
                </div>
            ))}
        </div>
    );
};

export default PositionalGrid;
